/**
 * The default currency to use when not available upon request.
 * TODO - Remove this once CurrenciesPlugin validation period is over
 */
const DEFAULT_CURRENCY = {
    name: 'USD',
    rate: 1,
    // eslint-disable-next-line no-template-curly-in-string
    template: '${{amount}}',
};

const Sources = {
    FreelancerPage: 'freelancer_page',
    GigPage: 'gig_page',
};

module.exports = {
    DEFAULT_CURRENCY,
    Sources,
};
